module.exports = __webpack_public_path__ + "img/1x.c08bf7e.jpg";